if(document.querySelectorAll('.build_box_pro_title_all .pro_title').length > 0){
var  pro_box = document.querySelectorAll('.build_box_pro_title_all .pro_title');
  var pro_img_new =  document.querySelectorAll('.build_box_pro_img');
  for(var i=0; i< pro_box.length; i++){
    pro_box[i].addEventListener("click", function () {
    var get_pro_img = this.getAttribute('data-box-img');
      for(var j=0; j< pro_box.length; j++){
              pro_box[j].classList.remove('active_pro_title');
            }   
      this.classList.add('active_pro_title'); 
      
       for(var h=0; h< pro_img_new.length; h++){
                 pro_img_new[h].classList.remove('active_product');
               }
       document.querySelector('.build_box_pro_img.'+get_pro_img).classList.add('active_product');
    });
  }
}


var box_product = document.querySelectorAll(".build_a_box");
var your__box = document.querySelector(".your-box h3");
var build_a_box_btn = document.querySelector("#box--submit");
var your_price = document.querySelector(".your-box-price h3");

var quantity = document.querySelectorAll('.flavours input[name="quantity"]');
var quantity_add = document.querySelectorAll('button[name="plus"]');

  for (let i = 0; i < box_product.length; i++){
      var box_count = box_product[0].dataset.boxCount;
      your__box.innerHTML = "Your Box (0/"+ box_count + ")";
      
      var box_price  = box_product[0].dataset.boxPrice;
      your_price.innerHTML = "Total Price: " + box_price;
    
    box_product[i].addEventListener("click", function boxQuantity(event){
      var box_count = box_product[i].dataset.boxCount;
      your__box.innerHTML = "Your Box (0/"+ box_count + ")";
      
      var box_price  = box_product[i].dataset.boxPrice;
      your_price.innerHTML = "Total Price: " + box_price;

      for(let q = 0; q < quantity.length; q++){
       quantity[q].value = 0;
       quantity_add[q].classList.remove('disabled');
       quantity_add[q].style.pointerEvents = 'auto';
      }
      if(build_a_box_btn){
      build_a_box_btn.classList.add('disabled');
      }
      
      var removeFlavour = document.querySelectorAll(".flavour_added");
      for(let r = 0; r < removeFlavour.length; r++){
        removeFlavour[r].classList.remove("flavour_added");
      }
      document.querySelector('.flavour_class').innerHTML = "";

   });
}

// var borderContainer = document.querySelectorAll(".card");
// for (let j = 0; j < borderContainer.length; j++) {
//   borderContainer[0].click();
//   borderContainer[j].addEventListener("click", function() {
//     (document.querySelector('.selected')) ? document.querySelector('.selected').classList.remove('selected') : '';
//     this.classList.add('selected');
    
//   });
// } 



if(build_a_box_btn){
build_a_box_btn.addEventListener("click", function cartTrigger(evt){
  
var borderContainer = document.querySelectorAll(".pro_title");
  for (let k = 0; k < borderContainer.length; k++){
    if (borderContainer[k].classList.contains("active_pro_title")){
      var box_contains = document.querySelector(".flavour_class").innerText;
      var selected_var = borderContainer[k].querySelector('input[name="id"]').value;

      $.ajax({
        url : "/cart/add.js",
        method : "POST",
        dataType:"json",
        data : { 
          quantity : 1,
          id : selected_var,
          properties: {
            'Box Products': box_contains
          }
        },
          success: function() {
            window.location.href = '/cart';
          }
      });
      
     /* var box_contains = document.querySelector(".flavour_class").innerText;
      var custom_data = borderContainer[k].querySelector("input[name='properties[Box Contents]']").value;
      var test = borderContainer[k].querySelector("input[name='properties[Box Contents]']").setAttribute('value', box_contains);
      borderContainer[k].querySelector(".quick-add__submit").click();*/
      
    }
  }
      
});
}

var quantity_sub = document.querySelectorAll('button[name="minus"]');

if(build_a_box_btn){
      build_a_box_btn.classList.add('disabled');
}
for(let l = 0; l < quantity.length; l++){
  quantity[l].addEventListener("change", function(evt){
var qtn_show = this.closest('.quantity').querySelector('.quantity__input');
    
    if(qtn_show.value == 0){
      qtn_show.style.display = "none";
    }else{
       qtn_show.style.display = "block";
    }
    
    // var flavour_name = this.parentElement;
    // var data_flavour_name = flavour_name.previousElementSibling;
    // var flavourName = data_flavour_name.dataset.name;
    // console.log(data_flavour_name);
    
    var your__box = document.querySelector(".your-box h3");
    var box_product = document.querySelectorAll(".build_a_box");

    this.closest('.multicolumn-card__info').querySelector(".flavour__name").classList.add('flavour_added');
    
    var flavour = document.querySelectorAll('.flavour__name');        
    var old_value = '';
    var new_value= '';
    var last_flavour = document.querySelectorAll('.flavour_added').length;
    var new_count = 0;
    

    var str = your__box.innerHTML;
    var split_str = str.split("(");
    var splitted_str = split_str[1].split('/');
    
    var check_zero = str.split("/");
    var is_zero = check_zero[1].split(')');
    var final_count = is_zero[0];

    
    for(let h = 0; h < flavour.length; h++ ){
      if(flavour[h].classList.contains("flavour_added")){
        var value = flavour[h].parentElement.querySelector('input').value;
        new_count = parseInt(new_count) + parseInt(value);
        
          if (value != 0){
          old_value = flavour[h].innerText;
          new_value = value + ' x ' + old_value +  '<br>' + new_value ;
            
          document.querySelector('.flavour_class').innerHTML = new_value ;
          }
          else{
            this.closest('.multicolumn-card__info').querySelector(".flavour__name").classList.remove('flavour_added');
          }
           if(last_flavour == 1 && value == 0){
            document.querySelector('.flavour_class').innerHTML = "";
           } 
        }
     }
    
    var new_str = str.replace(splitted_str[0], new_count);
    
   if(new_count > final_count){
      alert("Your box is now full");

    }
     var build_a_box_btn = document.querySelector("#box--submit");
    quantity_add.forEach(function (evt, index) {
     if(new_count == final_count){
         your__box.innerHTML = new_str; 
        quantity_add[index].classList.add('disabled');
        quantity_add[index].style.pointerEvents = 'none';
           
     build_a_box_btn.classList.remove('disabled');
     build_a_box_btn.style.pointerEvents = 'auto';
       
      }else{
        your__box.innerHTML = new_str;
         quantity_add[index].classList.remove('disabled');
         quantity_add[index].style.pointerEvents = 'auto';
       build_a_box_btn.classList.add('disabled');
     build_a_box_btn.style.pointerEvents = 'none';
      }
     }); 
    
  });
}


/**/


var order_detail = document.querySelectorAll(".account_detail_link");

if(order_detail){
for (i = 0; i < order_detail.length; i++) {
  order_detail[i].addEventListener("click", function() {
    var data_id = this.id;
    
    order_detail.forEach((element) => {
      element.classList.remove("active");
    });
    
    this.classList.add("active");
    
    var acc_details = document.querySelectorAll(".account_detail_inner div");
    acc_details.forEach((element) => {
      element.classList.remove("show");
    });
    document.querySelector(`.account_detail_inner .${data_id}`).classList.add("show");

    document.querySelector(".order_page .order_name").innerHTML = this.innerHTML;
    
  });
};
}


/* Hamper JS */

var hamper_headings = document.querySelectorAll(".hamper-product-heading");
var hamper_products = document.querySelectorAll(
  ".hamper--product-list .products"
);
var plus__icon = document.querySelectorAll(".hamper--product-list .plus__icon");
var minus__icon = document.querySelectorAll(
  ".hamper--product-list .minus__icon"
);

// Default open the first section
var show_first = hamper_products[0];
if (show_first) {
  show_first.style.display = "block";
  show_first.classList.add("open");
}
if (hamper_headings[0]) {
  hamper_headings[0].classList.add("open");
}

for (let i = 1; i < hamper_headings.length; i++) {
  hamper_headings[i].classList.add("close");
}

// Toggle the section and change the icon
for (let i = 0; i < hamper_headings.length; i++) {
  hamper_headings[i].addEventListener("click", function () {
    var off_products = hamper_headings[i].nextElementSibling;
    var plus__icon = hamper_headings[i].querySelector(
      ".hamper--product-list .plus__icon"
    );
    var minus__icon = hamper_headings[i].querySelector(
      ".hamper--product-list .minus__icon"
    );

    off_products.classList.toggle("open");
    off_products.style.display = off_products.classList.contains("open")
      ? "block"
      : "none";

    plus__icon.style.display = off_products.classList.contains("open")
      ? "none"
      : "block";
    minus__icon.style.display = off_products.classList.contains("open")
      ? "block"
      : "none";
  });
}

// Quantity selector field
var hamperQuantity = document.querySelectorAll('.hamper--product-list input[name="quantity"]');
var qtyInput = document.querySelectorAll(".hamper--product-list .products .card .quantity .quantity__input");
var checkoutBtnCc = document.querySelectorAll("#hamper--submit");
var bottomBar = document.querySelector(".sticky_bottom_bar");
var mobileBottomBar = document.querySelector(".mobile_sticky_bottom_bar");

function updateStickyBarContent() {
  var oldHamperValue = "";
  var oldHamPrice = 0;
  var stickyBarContent = document.querySelectorAll(".bar_elements_content");
  var hamperAdded = document.querySelectorAll(".hamper--product-list .hamper_product_added");
  var barUpdatePrice = document.querySelectorAll(".price_display");

  for (let h = 0; h < hamperAdded.length; h++) {
    var hamQty = hamperAdded[h].querySelector("input").value;

    if (hamQty != 0) {
      oldHamperValue += hamQty + " x " + hamperAdded[h].dataset.product + "\n";

      checkoutBtnCc.forEach(function (btn) {
        btn.classList.remove('disabled');
      });
    }

    oldHamPrice += ((hamQty * hamperAdded[h].dataset.price) / 100);
  }

  barUpdatePrice.forEach(function (price) {
    price.innerText = '$' + oldHamPrice.toFixed(2);
  });

  stickyBarContent.forEach(function (content) {
    content.innerText = oldHamperValue || "Add hamper products";
  });
}

function handleQuantityChange(index) {
  hamperQuantity[index].addEventListener("change", function (evt) {
    var productInfo = this.closest("[data-product]");
    var productQtyValue = this.closest(".quantity__input").value;

    if (productQtyValue != 0) {
      this.closest("li").classList.add("hamper_product_added");
    } else {
      this.closest("li").classList.remove("hamper_product_added");
      checkoutBtnCc.forEach(function (btn) {
        btn.classList.add('disabled');
      });
    }

    updateStickyBarContent();
    qtyInput[index].style.display = productQtyValue == 0 ? "none" : "block";
  });
}

for (let l = 0; l < hamperQuantity.length; l++) {
  handleQuantityChange(l);
}

function handleScroll() {
  var displayStyle = window.scrollY > 200 ? "block" : "none";
  bottomBar.style.display = displayStyle;
  mobileBottomBar.style.display = displayStyle;
}

window.addEventListener("scroll", handleScroll);

function checkoutFlow() {
  var selectedItem = [];
  var timestamp = 'Hamper-'+ Date.now();

  $('.hamper--product-list .hamper_product_added').each(function () {
    var getQtyVal = $(this).find("input").val();

    if (getQtyVal > 0) {
      var variantId = $(this).data('variant');
      var inputQty = $(this).find("input").val();

      selectedItem.push({ "vid": parseInt(variantId), "qty": parseInt(inputQty) });
    }
  });

  function checkout(ndx) {
    var vidNew = selectedItem[ndx].vid;
    var qtyNew = selectedItem[ndx].qty;

    $.ajax({
      url: "/cart/add.js",
      method: "POST",
      dataType: "json",
      data: {
        quantity: qtyNew,
        id: vidNew,
        properties: {
      'Product': timestamp
    }
      },
      beforeSend: function () {
        checkoutBtnCc.forEach(function (btn) {
          btn.querySelector(".loading-overlay").classList.remove('hidden');
          btn.classList.add('disabled');
          btn.querySelector(".hamper_btn_text").style.display = 'none';
        });
      },
      success: function () {
        ndx++;

        if (ndx === selectedItem.length) {
          window.location.href = '/cart';
        } else {
          checkout(ndx);
        }
      }
    });
  }

  checkout(0);
}

checkoutBtnCc.forEach(function (btn) {
  btn.addEventListener("click", function () {
    checkoutFlow();
  });
});



var mobileBarOpen = document.querySelector('.bar_elements');
var barContents = document.querySelector('.mobile_sticky_bottom_bar .mobile_bar_wrapper .bar_elements_content');
var caretRotate = document.querySelector('.bar-icon-caret');

mobileBarOpen.addEventListener("click", function () {
  if (barContents.classList.toggle('active')) {
    barContents.style.display = 'block';
    caretRotate.style.transform = 'rotate(180deg)';
  } else {
    barContents.style.display = 'none';
    caretRotate.style.transform = 'rotate(0deg)';
  }
});


